<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item to="/publications">publication</el-breadcrumb-item>
        <el-breadcrumb-item>Content</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="publicationsMainBox">
      <h1>{{pdfDict.title}}</h1>
      <div class="tipsBox">
        <span class="sp1">
          <i class="el-icon-time"></i>
          {{pdfDict.create_time}}
        </span>
        <span class="sp2">
          <i class="el-icon-view"></i>
          {{pdfDict.view}}
        </span>
      </div>
      <div class="pdfvuer">
        <div class="pageTurning">
          <div class="footer-nav-link footer-nav-left">
            <span  v-if="pdfDict.pann.pre.length != 0"  @click="gotopreFn(pdfDict.pann.pre.id)">上一篇：
            {{pdfDict.pann.pre.title}}  <img src="@/assets/images/pdfIcon.png"/></span>
            <span v-if="pdfDict.pann.pre.length == 0">已经是第一篇了</span>
          </div>
          <div class="footer-nav-link footer-nav-right">
            <span v-if=" pdfDict.pann.next.length != 0" @click="gotoNextFn(pdfDict.pann.next.id)">
              下一篇：
           {{pdfDict.pann.next.title}}<img src="@/assets/images/pdfIcon.png"/>
            </span>
            <span v-if="pdfDict.pann.next.length == 0">已经是最后一篇了</span>
          </div>
        </div>
        <iframe :src="pdfsrc" width="100%" height="1000"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/publications.less";
import apiSign from "../assets/js/apiSign";

export default {
  data() {
    return {
      pdfsrc: "",
      pdfid: "1",
      pdfDict: { title: "", view: "", create_time: "", pann: {} }
    };
  },
  mounted() {
    this.pdfid = this.$route.params.id;
    this.getPdf();
  },
  methods: {
    getPdf() {
      let field = { rtime: apiSign.getTime(), id: this.pdfid };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/publications/info", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          if (resp.data.code) {
            this.$message({
              type: "error",
              message: resp.data.msg
            });
          } else {
            this.pdfsrc = resp.data.data.pdf;
            this.pdfDict = {
              title: resp.data.data.title,
              view: resp.data.data.view,
              create_time: resp.data.data.create_time,
              pann: resp.data.data.pann
            };
          }
        });
    },
    gotopreFn(id){
      this.pdfid = id;
      this.getPdf();
    },
    gotoNextFn(id){
      this.pdfid = id;
      this.getPdf();

    },
    findPos(obj) {
      return obj.offsetTop;
    }
  }
};
</script>